import { greyLeads, purpleLeads, DEALS_TOPBAR_ICON_GREY, DEALS_TOPBAR_ICON_PURPLE } from '../../assets/hostedassets';
import { INVESTOR_ROUTES } from '../../utils/constants/routesConst';
import { MobileTabConfig } from './types';

export const MOBILE_TAB_CONFIG: MobileTabConfig[] = [
    {
        key: 'leads',
        label: 'Leads',
        icon: greyLeads,
        activeIcon: purpleLeads,
        route: INVESTOR_ROUTES.SCAN,
        permissionKey: 'SCAN',
    },
    {
        key: 'deals',
        label: 'Deals',
        icon: DEALS_TOPBAR_ICON_GREY,
        activeIcon: DEALS_TOPBAR_ICON_PURPLE,
        route: INVESTOR_ROUTES.DEALS,
        permissionKey: 'DEALS',
    },
];
